window.OSM = window.OSM ?? {};
OSM.MapViewInterface = class MapViewInterface {

    /** @type {OSM.MapLibreMap} */
    map;

    /**
     *
     * @param {HTMLElement} osmMap
     */
    constructor(osmMap) {

        const urlParams = new URLSearchParams(window.location.search);
        const mapConfig = urlParams.get('map_config');

        const mapConfigID = mapConfig ? mapConfig : osmMap.dataset.mapConfigId

        /** @type {IMapProps} */
        let config = mapConfigID ? (OSM.MapConfigs[mapConfigID] ?? null) : null;
        config = config ?? OSM.MapConfigs.default;
        config = config ?? {};
        /** @type {IMapProps} */
        const coreConfig = OSM.MapConfigs.core;


        /** @type {IMapProps} */
        const props = OSM.deepCopyObjects(config);

        const mapID = this.requireMapID(osmMap);
        const userMarkerProps = this.collectUserMarkerProps(osmMap, props.userMarker ?? null);
        if(userMarkerProps){
            props.userMarker = userMarkerProps
        }

        const singleMarkerIsPrimaryMarker = config.singleMarkerIsPrimaryMarker ?? (coreConfig.singleMarkerIsPrimaryMarker ?? false);
        const markers = this.collectMarkers(osmMap);
        if(Object.keys(markers).length){
            if(singleMarkerIsPrimaryMarker && Object.keys(markers).length === 1){
                /** @type {IMarkerProps} */
                const fromMarkerProps = markers[Object.keys(markers)[0]]
                props.primaryMarker = this.createPrimaryMarkerProps(fromMarkerProps, props.primaryMarker ?? null);
            } else {
                props.cluster = this.createClusterProps(markers, props.cluster ?? null);
            }
        }
        const zoomLevel = parseInt(osmMap.dataset.zoom);
        if(zoomLevel){
            props.mapOptions = {
                ...props.mapOptions,
            }
            props.mapOptions.zoom = zoomLevel;
            if(props.userMarker){
                props.userMarker.defaultZoomLevel = zoomLevel;
            }
            if(props.primaryMarker){
                props.primaryMarker.defaultZoomLevel = zoomLevel;
            }
        }

        osmMap.innerHTML = "";
        osmMap.classList.add("received");
        this.map = new OSM.MapLibreMap(mapID, props);
    }


    /**
     *
     * @param {HTMLElement} osmMap
     * @returns {string}
     */
    requireMapID(osmMap) {
        let mapID = osmMap.id;
        if(!mapID){
            const prefix = "mapLibreMap"
            let mapNumber = 1;
            mapID = prefix + mapNumber;
            while(document.querySelectorAll("#"+mapID).length){
                mapNumber ++;
                mapID = prefix + mapNumber;
            }
            osmMap.id = mapID;
        }
        return mapID;
    }

    /**
     *
     * @param {HTMLElement} osmMap
     * @param {IBasicMarkerProps|null} configProps
     * @returns {IBasicMarkerProps|null}
     */
    collectUserMarkerProps(osmMap, configProps) {

        let userLat = osmMap.dataset.userLat ?? null;
        let userLng = osmMap.dataset.userLng ?? null;

        if(!OSM.isNumeric(userLat) || !OSM.isNumeric(userLng)) {
            userLat = document.querySelectorAll("#user_set_lat")[0]?.innerHTML ?? null;
            userLng = document.querySelectorAll("#user_set_lng")[0]?.innerHTML ?? null;
        }

        if(!OSM.isNumeric(userLat) || !OSM.isNumeric(userLng)) {
            userLat = document.querySelectorAll("#user_lat")[0]?.innerHTML ?? null;
            userLng = document.querySelectorAll("#user_lng")[0]?.innerHTML ?? null;
        }

        /** @type {maplibregl.LngLat|null} */
        let lngLat = null;
        if(!OSM.isNumeric(userLat) || !OSM.isNumeric(userLng)) {
            if(!parseInt(osmMap.dataset.withUser ?? "0")){
                return null;
            }
        } else {
            userLat = parseFloat(userLat);
            userLng = parseFloat(userLng);
            lngLat = new maplibregl.LngLat(userLng, userLat)
        }
        /** @type {IBasicMarkerProps} */
        const userMarkerProps = {
            ...configProps
        };
        if(lngLat){
            userMarkerProps.lngLat = lngLat
        }
        return userMarkerProps;
    }

    /**
     *
     * @param {HTMLElement} osmMap
     * @returns {IMarkersProps}
     */
    collectMarkers(osmMap) {

        let children = osmMap.children;
        let found = false;
        for(let child of children){
            if(child.classList.contains("marker")){
                found = true;
                break;
            }
        }
        if(!found){
            const markers = osmMap.getElementsByClassName('marker');
            const firstMarker = markers[0] ?? null;
            if(firstMarker){
                children = firstMarker.parentNode.children;
            }
        }
        let index = -1;
        const markersProps = {};
        for(let child of children){
            if(!child.classList.contains("marker")){
                continue;
            }
            const latitude = OSM.isNumeric(child.dataset.lat ?? null) ? parseFloat(child.dataset.lat) : null;
            const longitude = OSM.isNumeric(child.dataset.lng ?? null) ? parseFloat(child.dataset.lng) : null;
            if((latitude === null) || (longitude === null)){
                continue;
            }
            index ++;
            let markerID = child.dataset.id ?? null;
            markerID = OSM.isInt(markerID) ? parseInt(markerID) : markerID;
            markerID = markerID ?? "index_"+index;

            markersProps[markerID] = {
                lngLat: new maplibregl.LngLat(longitude, latitude),
                popupContent: child.innerHTML
            }
        }

        return markersProps
    }

    /**
     *
     * @param {IMarkerProps} fromMarkerProps
     * @param {IMarkerProps|null} configProps
     * @returns {IMarkerProps}
     */
    createPrimaryMarkerProps(fromMarkerProps, configProps) {
        return {
            ...configProps,
            ...fromMarkerProps
        }
    }

    /**
     *
     * @param {IMarkersProps} markers
     * @param {IMapClusterProps|null} configProps
     * @returns {IMapClusterProps}
     */
    createClusterProps(markers, configProps) {
        return {
            ...configProps,
            markers: markers
        }
    }
}

/** @type {OSM.MapViewInterface[]} */
OSM.viewInterfaces = [];

$(document).ready(() =>
{
    if(OSM.viewInterfaces.length){
        return;
    }
    const osmMaps = document.querySelectorAll('.osm-map.populate');
    for(let osmMap of osmMaps){
        OSM.viewInterfaces.push(new OSM.MapViewInterface(osmMap));
    }
});